<template>
    <v-dialog v-model="dialog" max-width="600" scrollable>
        <v-card >

            <v-card-title class="pb-1">
                <div class="title font-weight-light">Detalles de la cita</div>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="currentUser && event && event.schedule && event.schedule.specialist && (currentUser.id === event.schedule.specialist.id)"
                        small rounded depressed color="primary"
                        @click="goToAppointment"
                >Ir a la cita</v-btn>
                <v-btn fab small @click="hide" depressed>
                    <v-icon>fa-times</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-title v-if="title" class="py-0">
                <div class="subtitle font-weight-light">{{title}}</div>
            </v-card-title>

            <v-card-text v-if="event">
                <attention-summary :event="event" />
            </v-card-text>

          <v-card-actions
              class="pa-3"
              v-if="event && event.appointment_documents && event.appointment_documents.length > 0"
          >

            <v-chip
                color="secondary"
                v-for="(file) in event.appointment_documents"
                @click="openDoc(file.path)"
                small
                outlined
                :key="file.id">
              <v-icon size="14" class="mr-1">fa-file-download</v-icon>{{file.name}}
            </v-chip>

          </v-card-actions>

        </v-card>
    </v-dialog>
</template>
<script>

    import AttentionSummary from './AttentionSummary'
    import {mapMutations, mapState} from 'vuex'

    export default{
        components: {AttentionSummary},
        data(){
            return {
                dialog: false,
                event: null
            }
        },
        methods:{
            ...mapMutations('clientAttention', [
                'setEvent'
            ]),
            openDoc(path){
              window.open(path, '_blank')
            },
            goToAppointment(){
                const vm = this
                setTimeout(function(){
                    vm.setEvent(vm.event)
                }, 500)
                vm.$router.push({
                    name: 'panel.provider.specialist_daily_schedule',
                   /* params: {
                        event: vm.event
                    }*/
                })
                vm.$emit('click:event-load')
            },
            show(evt){
                var vm = this
                vm.dialog = true
                vm.event = evt

            },
            hide(){
                var vm = this
                vm.dialog = false
            }
        },
        computed: {
          ...mapState(['currentUser']),
          title(){
              var vm = this
              if(!vm.event) return ''

              return vm.$moment(vm.event.date).format('ddd') + ', ' +
                  vm.$moment(vm.event.date).format('D') + ' ' +
                  vm.$moment(vm.event.date).format('MMMM') + ' del ' +
                  vm.$moment(vm.event.date).format('YYYY') + ' | ' +
                  vm.$moment( vm.event.time, 'HH:mm:ss').format('HH:mm') + ' hrs.'
          }
        },
        watch:{
            dialog(val){
                if(!val){
                    var vm = this
                    setTimeout(function(){
                        vm.event = null
                    }, 500)
                }
            }
        }
    }
</script>
